import type { RunStatus } from "@agentdash/shared";

const STATUS_LABEL: Record<RunStatus, string> = {
  running: "running",
  ok: "succeeded",
  error: "errored",
  unknown: "unknown",
};

export function StatusDot({ status }: { status: RunStatus }) {
  const cls =
    status === "running"
      ? "dot running"
      : status === "ok"
        ? "dot ok"
        : status === "error"
          ? "dot error"
          : "dot unknown";
  // Status is otherwise encoded by colour only; role="img" + aria-label give
  // assistive tech a reliable text equivalent (a bare title on a span isn't).
  const label = `status: ${STATUS_LABEL[status] ?? status}`;
  return <span className={cls} role="img" aria-label={label} title={status} />;
}
